<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: left; align-self: end;">Selected Portal: {{ portal?.name }}</h4>
    </div>
    <div class="col-sm-6">
        <h1 class="page-label">Return Devices - Dashboard</h1>
    </div>
    <!-- <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: right; align-self: end;">Shipment Number: {{ this.state?.attemptDto?.shipmentNbr }}</h4>
    </div> -->
</div>

<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <thead>
        <tr role="row" class="tablesorter-headerRow">
            <th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllAssetsSelected()"
										(change)="setAllAssetsSelected($event)" />
								</div>
			</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Asset ID</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">FN Number</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Sales Order Number</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Part Number/Inventory ID</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Shipment Number</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Status</div>
            </th>
        </tr>
    </thead>
    
    <tbody>
        <tr role="row" *ngFor="let asset of assets index as i;">
            <td><input type="checkbox" [(ngModel)]="asset.selected" /></td> 
            <td>
                {{ asset?.assetId }}
            </td>
            <td>
                {{ asset?.fnNumber }}
            </td>
            <td>
                {{ asset?.orderNbr }}
            </td>
            <td> 
                {{ asset?.inventoryID }}
            </td>
            <td>
                {{ asset?.shipmentNbr }}
            </td>
            <td>
                {{ asset?.status }}
            </td>
        </tr>
    </tbody>
</table>

<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onStartReaderClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Start</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onStopReaderClicked()" [disabled]="!isReaderStarted() || isActionBeingPerformed">Stop</button>
    </div>
    <div class="col-sm-4">

    </div>
    <div class="col-sm-7">
        <button class="submit btn btn-primary" (click)="onClearReadsClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Clear Reads</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onClearAllClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Clear All</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onProcessClicked()" [disabled]="isReaderStarted() || isActionBeingPerformed">Process Return</button>
    </div>
</div>

<div class="print-container">
    <h1 class="page-label">&nbsp;</h1>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
